import { Site } from './site.model';
export class Customer {
	id: number;
	name: string;
	expanded? : boolean;
	sites: Site[];
	dealersIDs: number[];
	had_act_intelligence: boolean;
	serviceDealersIDs: number[];
}